<template>
  <div class="youtube--item">
    <div v-if="link">
      <div class="iframe--container">
        <iframe
          v-if="embedUrl && embedUrl.length"
          width="560"
          height="390"
          :src="embedUrl"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <h3>{{ link.title }}</h3>
      <span v-if="date" class="date">{{ date }}</span>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "youtube",
  mounted() {
    this.setUrl();
    this.setDate();
  },
  updated() {
    this.setUrl();
    this.setDate();
  },
  computed: {},
  props: {
    link: Object
  },
  components: {},
  methods: {
    setUrl: function() {
      this.embedUrl = `https://www.youtube.com/embed/${this.extractYoutubeId(this.link.url)}`;
    },
    setDate: function() {
      if (this.link && this.link.date) this.date = moment(this.link.date).format("DD MMM YYYY");
    },
    extractYoutubeId: function(url) {
      // eslint-disable-next-line
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }
  },
  data() {
    return {
      embedUrl: "",
      date: undefined
    };
  }
};
</script>

<style lang="scss">
@import "../style/components/link";
</style>
